<template>
  <div>
    <div class="w-full mb-4">
      <elsa-v-select
        class="mb-2"
        :options="buildings"
        v-model="selectedBuilding"
        label="address"
        :reduce="item => item.id"
        :append-to-body="true"
        html-label="Дом"
        :clearable="false"
      />

    </div>

    <div class="w-full mb-4">
      <elsa-v-select
        class="mb-2"
        :options="apartments"
        v-model="selectedApartment"
        :disabled="isApartmentsLoading"
        :get-option-label="(item) => isApartmentsLoading ? 'Загрузка...' : `${item.number} (Л/С: ${item.account_number})`"
        :reduce="item => item.id"
        :append-to-body="true"
        html-label="Помещение"
        :clearable="false"
      >
        <template slot="no-options">Помещения не найдены</template>
      </elsa-v-select>
    </div>

    <div class="w-full text-center">
      <app-button color="success" :disabled="selectedBuilding === null || selectedApartment === null" @click="addUser">
        Добавить
      </app-button>
    </div>
  </div>
</template>

<script>
import modal           from "../../../mixins/modalContext";
import notifyHttpError from "../../../mixins/notifyHttpError";

export default {
  name:     "UserAppendToAnotherApartmentPopup",
  props:    ['buildingId', 'userId', 'relation'],
  mixins:   [notifyHttpError, modal],
  data() {
    return {
      selectedBuilding:    null,
      selectedApartment:   null,
      apartments:          [],
      isApartmentsLoading: false,
    };
  },
  computed: {
    buildings() {
      return this.$store.getters['appUser/houses'];
    },
  },
  mounted() {
    this.selectedBuilding = this.buildingId;
    // this.loadApartments();
  },
  methods:  {
    async loadApartments() {
      this.apartments = [];
      this.selectedApartment = "Загрузка...";
      this.isApartmentsLoading = true;
      this.$http.get('all_aparts', { params: { buildings_id: this.selectedBuilding } }).then(
        ( { data } ) => this.apartments = data,
        () => this.apartments = [],
      ).finally(() => {
        this.$nextTick(() => {
          this.isApartmentsLoading = false;
          this.selectedApartment = null;
        });
      });
    },
    async addUser() {
      const body = {
        relation:      this.relation,
        users_id:      this.userId,
        apartments_id: this.selectedApartment,
        buildings_id:  this.selectedBuilding,
      };

      this.$http.post('ua_manager', body).then(( { data } ) => {
        if (data === 'already exist') {
          this.$vs.notify({
            color: 'danger',
            text:  'Пользователь не добавлен',
            title: 'Данный пользователь уже существует в выбранном помещении',
          });
          return;
        }
        this.$vs.notify({
          color: 'success',
          text:  'Успешное сохранение',
          title: `Пользователь добавлен в выбранное помещение`,
        });
        this.modalResolve();
      }, this.notifyHttpError);
    },
  },
  watch:    {
    selectedBuilding() {
      this.loadApartments();
    },
  },
};
</script>

<style scoped>

</style>
